import { MigrationState } from '@or-sdk/contacts';
import { SDK, MIGRATIONS } from '../constants';

/**
 * When we are installing or updating HITL - "Contacts" service might not yet be installed.
 * In this case we should initialize "Contacts" by running migrations.
 * TODO: Contacts also can have versions in the future?
 */
export const useContactsIntegration = () => {
  /** Check the state of "Contacts" service and run migrations if required */
  const checkOrUpdateContacts = async (args: { mPending: string[]; }) => {
    try {
      const status = await checkContacts(args);
      if (status === 'skip' || status === 'ready') {
        return;
      }

      /** TODO: Can we use this method while migrations are already running? */
      if (status === 'migrate' || status === 'wait') {
        await SDK.HttpSDK.contacts.migrationsApi.pollMigrationUntilDone();
      }
    } catch (e: any) {
      console.error('Error while checking or updating "Contacts" service!', e);
      throw e;
    }
  };

  const checkContacts = async (args: { mPending?: string[]; }) => {
    const { mPending = [] } = args;
    if (!mPending.includes(MIGRATIONS.NEW_CONTACTS)) {
      return 'skip';
    }

    const status = await SDK.HttpSDK.contacts.migrationsApi.getMigrationState();
    switch (status) {
      case MigrationState.Done:
        return 'ready';
      case MigrationState.ToDo:
      case MigrationState.NotStarted:
        return 'migrate';
      case MigrationState.InProgress:
        return 'wait';
    }
  };

  return { checkOrUpdateContacts };
};
